import { LessonTaskStepWithLessonAndTask } from '../../main/types/asset/lesson.types.ts';
import { getLessonsUtil } from '../../main/utils/asset/lessons.util.ts';
import { createMemoizedSelector } from '../../main/utils/selector/create-memoized-selector.ts';

import { selectCurrentLessonTaskStepKey } from './current-lesson-task-step-key.selector.ts';

export const selectCurrentLessonTaskStep = createMemoizedSelector(
  selectCurrentLessonTaskStepKey,
  (currentLessonTaskStepKey): LessonTaskStepWithLessonAndTask => {
    const lessonsUtil = getLessonsUtil();
    return lessonsUtil.getLessonTaskStep(currentLessonTaskStepKey)!;
  }
);
